import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { RouteGuard } from './services/route.guard';
import { RegionGuard } from './services/region.guard';
import { environment } from 'src/environments/environment';
import { ITCConsultingPageComponent } from './homepage/itc-home/itc-consulting-page/itc-consulting-page.component';

const setHomepage = environment.HOMEPAGE;

const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('src/app/auth/auth.module').then(m => m.AuthModule),
        data: { refreshComponent: true },
    },
    {
        path: 'home',
        loadChildren: () => import('src/app/homepage/homepage.module').then(m => m.HomepageModule),
        data: { refreshComponent: true },
    },
    {
        path: 'contact-us',
        loadChildren: () => import('src/app/contact-us-page/contact-us-page.module').then(m => m.ContactUsPageModule),
        data: { refreshComponent: true },
    },
    {
        path: 'itc-consulting-page',
        component: ITCConsultingPageComponent
    },
    {
        path: 'vmanicode-home',
        loadChildren: () => import('src/app/homepage/homepage.module').then(m => m.HomepageModule),
        data: { refreshComponent: true },
    },
    {
        path: 'vmanicori-home',
        loadChildren: () => import('src/app/homepage/homepage.module').then(m => m.HomepageModule),
        data: { refreshComponent: true },
    },
    {
        path: 'vmanicosi-home',
        loadChildren: () => import('src/app/homepage/homepage.module').then(m => m.HomepageModule),
        data: { refreshComponent: true },
    },
    {
        path: 'itc-home',
        loadChildren: () => import('src/app/homepage/homepage.module').then(m => m.HomepageModule),
        data: { refreshComponent: true },
    },
    {
        path: 'INDIA',
        loadChildren: () => import('src/app/homepage/homepage.module').then(m => m.HomepageModule),
        canActivate: [RegionGuard]
    },
    {
        path: 'USA',
        loadChildren: () => import('src/app/homepage/homepage.module').then(m => m.HomepageModule),
        canActivate: [RegionGuard]
    },
    {
        path: 'profile',
        loadChildren: () => import('src/app/my-profile/my-profile.module').then(m => m.MyProfileModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'Company',
        loadChildren: () => import('src/app/company/company.module').then(m => m.CompanyModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'Service',
        loadChildren: () => import('src/app/delivery-services/delivery-services.module').then(m => m.DeliveryServicesModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'Products',
        loadChildren: () => import('src/app/product/product.module').then(m => m.ProductModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'Solutions',
        loadChildren: () => import('src/app/product-solutions/product-solutions.module').then(m => m.ProductSolutionsModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'save-my-ip',
        loadChildren: () => import('src/app/platforms-page/platforms-page.module').then(m => m.PlatformsPageModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'Platforms',
        loadChildren: () => import('src/app/platform/platform.module').then(m => m.PlatformModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'Vmanicode',
        loadChildren: () => import('src/app/vmanicode/vmanicode.module').then(m => m.VmanicodeModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'Vmanicori',
        loadChildren: () => import('src/app/vmanicori/vmanicori.module').then(m => m.VmanicoriModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'Blogs',
        loadChildren: () => import('src/app/blogs/blogs.module').then(m => m.BlogsModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'Careers',
        loadChildren: () => import('src/app/careers/careers.module').then(m => m.CareersModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'story/:name',
        loadChildren: () => import('src/app/product/product.module').then(m => m.ProductModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'blog/:name',
        loadChildren: () => import('src/app/platform/platform.module').then(m => m.PlatformModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'testimonial/:name',
        loadChildren: () => import('src/app/platform/platform.module').then(m => m.PlatformModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'industies/:name',
        loadChildren: () => import('src/app/platform/platform.module').then(m => m.PlatformModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'patners/:name',
        loadChildren: () => import('src/app/platform/platform.module').then(m => m.PlatformModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'vmanico-helps-to-protect-ip',
        loadChildren: () => import('src/app/vmanico-helps/vmanico-helps.module').then(m => m.VmanicoHelpsModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'vmanico-helps-to-protect-cfo',
        loadChildren: () => import('src/app/vmanico-cfo/vmanico-cfo.module').then(m => m.VmanicoCfoModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'vmanico-helps-to-protect-coo',
        loadChildren: () => import('src/app/vmanico-coo/vmanico-coo.module').then(m => m.VmanicoCOOModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'vmanico-helps-to-protect-cto',
        loadChildren: () => import('src/app/vmanico-cto/vmanico-cto.module').then(m => m.VmanicoCTOModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'vmanico-helps-to-protect-ceo',
        loadChildren: () => import('src/app/vmanico-ceo/vmanico-ceo.module').then(m => m.VmanicoCeoModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'support',
        loadChildren: () => import('src/app/support-page/support-page.module').then(m => m.SupportPageModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'whytop',
        loadChildren: () => import('src/app/why-top-rated/why-top-rated.module').then(m => m.WhyTopRatedModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'whatweare',
        loadChildren: () => import('src/app/whatareweoffering/whatareweoffering.module').then(m => m.WhatareweofferingModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'leadership',
        loadChildren: () => import('src/app/leadership/leadership.module').then(m => m.LeadershipModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'terms-of-use',
        loadChildren: () => import('src/app/terms-of-use/terms-of-use.module').then(m => m.TermsOfUseModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'security',
        loadChildren: () => import('src/app/security-page/security-page.module').then(m => m.SecurityPageModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'privacy',
        loadChildren: () => import('src/app/privacy-page/privacy-page.module').then(m => m.PrivacyPageModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'trademark-policy',
        loadChildren: () => import('src/app/trademark-policy-page/trademark-policy-page.module').then(m => m.TrademarkPolicyPageModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'ip-policy',
        loadChildren: () => import('src/app/ip-policy-page/ip-policy-page.module').then(m => m.IpPolicyPageModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'data-protection',
        loadChildren: () => import('src/app/data-protection-page/data-protection-page.module').then(m => m.DataProtectionPageModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'report',
        loadChildren: () => import('src/app/report-page/report-page.module').then(m => m.ReportPageModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'help',
        loadChildren: () => import('src/app/help-page/help-page.module').then(m => m.HelpPageModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    {
        path: 'about-us',
        loadChildren: () => import('src/app/about-us/about-us.module').then(m => m.AboutUsModule),
        canActivate: [RouteGuard],
        data: { refreshComponent: true },
    },
    // {
    //     path: '',
    //     redirectTo: 'home',
    //     pathMatch: 'full',
    // },
    {
        path: '**',
        redirectTo: setHomepage,
        pathMatch: 'full',
    },
    {
        path: 'consulting', component: ITCConsultingPageComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled'
    })],
    exports: [RouterModule]
})

export class AppRoutingModule { }
